//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        message: String  //定义传值的类型
    },
    data() {
        return {
            // tit: '暂无订单',
        }
    },
    //生命周期之挂载完成
    methods: {

    }
}



// WEBPACK FOOTER //
// ./src/components/empty/index.vue